const palette = {
  neutral100: '#FFFFFF',
  neutral200: '#F9F9F9',
  neutral300: '#F3F3F3',
  neutral400: '#E2E2E2',
  neutral500: '#909090',
  neutral600: '#5E5E5E',
  neutral700: '#232323',
  neutral800: '#191919',
  neutral900: '#000000',

  primary100: '#F4E0D9',
  primary200: '#E8C1B4',
  primary300: '#DDA28E',
  primary400: '#D28468',
  primary500: '#b92f2f',
  primary600: '#a72a2a',
  primary700: '#942626',
  primary800: '#822121',
  primary900: '#6f1c1c',

  success100: '#A4CBA9',
  success200: '#95C29B',
  success300: '#85B98D',
  success400: '#76B17E',
  success500: '#67A870',
  success600: '#5D9765',
  success700: '#52865A',
  success800: '#48764E',
  success900: '#3E6543',

  warning100: '#FFC369',
  warning200: '#FFB950',
  warning300: '#FFAF37',
  warning400: '#FFA51E',
  warning500: '#FF9B05',
  warning600: '#E68C05',
  warning700: '#CC7C04',
  warning800: '#B36D04',
  warning900: '#995D03',

  error100: '#D19DAA',
  error200: '#C98D9C',
  error300: '#C17D8E',
  error400: '#BA6C80',
  error500: '#B25C72',
  error600: '#A05367',
  error700: '#8E4A5B',
  error800: '#7D4050',
  error900: '#6B3744',

  info50: '#81C2E3',
  info100: '#67B5DD',
  info200: '#4EA9D8',
  info300: '#359DD2',
  info400: '#1B90CD',
  info500: '#0284C7',
  info600: '#0277B3',
  info700: '#026A9f',
  info800: '#015C8B',
  info900: '#014F77',

  overlay20: 'rgba(25, 16, 21, 0.2)',
  overlay50: 'rgba(25, 16, 21, 0.5)',
} as const;

export const colors = {
  /**
   * The palette is available to use, but prefer using the name.
   * This is only included for rare, one-off cases. Try to use
   * semantic names as much as possible.
   */
  palette,
  /**
   * A helper for making something see-thru.
   */
  transparent: 'rgba(0, 0, 0, 0)',
  /**
   * Shorthand for white color.
   */
  white: palette.neutral100,
  /**
   * Shorthand for black color.
   */
  black: palette.neutral900,
  /**
   * The primary branding color.
   */
  primary: palette.primary500,
  /**
   * The primary background color.
   */
  primaryBackground: '#F1D5D5',
  /**
   * The lighter variation of the primary background color.
   */
  primaryBackgroundLight: '#FBF5F5',
  /**
   * The default text color in many components.
   */
  text: palette.neutral700,
  /**
   * Secondary text information.
   */
  textDim: palette.neutral600,
  /**
   * The default color of the screen background.
   */
  background: palette.neutral100,
  /**
   * The background for the avatar header.
   */
  avatarBackground: '#F6F6F6',
  /**
   * The default border color.
   */
  border: palette.neutral400,
  /**
   * Error text.
   */
  error: palette.error500,
  /**
   * Info text.
   */
  info: palette.info500,
  /**
   * Warning text.
   */
  warning: palette.warning500,
  /**
   * Success text.
   */
  success: palette.success500,
  /**
   * Colors for the alert component.
   */
  alerts: {
    /**
     * Error alert text.
     */
    error: palette.neutral100,
    /**
     * Error alert background.
     */
    errorBackground: palette.error100,
    /**
     * Info alert text.
     */
    info: palette.neutral100,
    /**
     * Info alert background.
     */
    infoBackground: palette.info100,
    /**
     * Warning alert text.
     */
    warning: palette.neutral900,
    /**
     * Warning alert background.
     */
    warningBackground: palette.warning100,
    /**
     * Success alert text.
     */
    success: palette.neutral100,
    /**
     * Success alert background.
     */
    successBackground: palette.success100,
  },
  /**
   * External links such as email, phone and websites.
   */
  link: '#1e5dff',
  /**
   * Displaying appointment confirmation.
   */
  appointmentConfirmation: '#008000',
};
